import { useEffect, useState } from 'react'

import { fetchMatchConfig, type MatchConfig } from 'services/matchConfigService'

interface UseMatchConfigReturn {
  data: MatchConfig | null
  isLoading: boolean
  error: Error | null
}

export const useMatchConfig = (customerId: string, eventGuid: string): UseMatchConfigReturn => {
  const [data, setData] = useState<MatchConfig | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!customerId || !eventGuid) {
      setIsLoading(false)
      return
    }

    const loadMatchConfig = async () => {
      try {
        setIsLoading(true)
        setError(null)
        const config = await fetchMatchConfig(customerId, eventGuid)
        setData(config)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch match config'))
      } finally {
        setIsLoading(false)
      }
    }

    loadMatchConfig()
  }, [customerId, eventGuid])

  return { data, isLoading, error }
}
